import { Translation } from '@ps/web-shared-components';
import React from 'react';

import CTAButton from '../../../CTAButton/CTAButton';
import Container from '../../../Container/Container';

import {
  TXTWCL_WhatXs_your_citizenshipX,
  TXTWCL_Your_citizenship
} from './RMFIdentityVerification.messages.json';
import Fields from './components/Fields/Fields';

const RMFIdentityVerification: React.FC = () => (
  <Container
    page={RMFIdentityVerification}
    headerProps={{
      title: <Translation {...TXTWCL_Your_citizenship} />
    }}
    pageTopTitle={<Translation {...TXTWCL_WhatXs_your_citizenshipX} />}
  >
    <Fields formVisible />
    <CTAButton />
  </Container>
);

RMFIdentityVerification.displayName = 'RMFIdentityVerification';

export default RMFIdentityVerification;
